import { EntityList } from '@/types/Entity'
import { CONSTANTS } from '@/types/enum/constants'

const getIsManagerDelegateCompany = (loggedUserRoles: string[], entity: EntityList | string): boolean => {
  if (!loggedUserRoles) return false
  if (entity == EntityList.PHARMEDISCHOOL) {
    return (
      !!loggedUserRoles.find(value =>
        [CONSTANTS.ROLE_DYNAMIC_ROUTE_SCHOOL_MANAGER_LEARNER].find(role => role === value)
      ) || false
    )
  } else if (entity == EntityList.PHARMEDISTORE) {
    return (
      !!loggedUserRoles.find(value =>
        [CONSTANTS.ROLE_DYNAMIC_ROUTE_PLV_PHARMACIEN, CONSTANTS.ROLE_DYNAMIC_ROUTE_STORE_MANAGE].find(
          role => role === value
        )
      ) || false
    )
  } else if (entity == EntityList.PHARMEDICARE) {
    return (
      !!loggedUserRoles.find(value =>
        [CONSTANTS.ROLE_DYNAMIC_ROUTE_CARE_MANAGE].find(role => role === value)
      ) || false
    )
  } else if (entity === 'DELEGATE_PHARMACIEN_CO_TITU') {
    return (
      !!loggedUserRoles.find(value =>
        [CONSTANTS.ROLE_DYNAMIC_ROUTE_GROUP_PHARMACIEN].find(role => role === value)
      ) || false
    )
  }
  return false
}

export default getIsManagerDelegateCompany
